export const AgentEventDataUnresolvedReason = {
    NOT_IN_DOCUMENT: "not_in_document",
    NO_MATCH: "no_match",
    MULTIPLE_MATCHES: "multiple_matches"
};
export function isAgentEventDataSuggestion(value, dataType) {
    if (typeof value !== "object" ||
        value === null ||
        !("agent" in value) ||
        !("dataType" in value) ||
        !("data" in value) ||
        !value.data) {
        return false;
    }
    if (dataType !== undefined) {
        return value.dataType === dataType;
    }
    return true;
}
//# sourceMappingURL=sessions.eventData.js.map